//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const DesignCollectiveQuery: any = {
    GetDesignCollectiveListData: `${Backofficebff}/v1/designcollective/designcollectives`,
    GetDesignCollectiveDetailById: `${Backofficebff}/v1/designcollective`,
    GetAttachment: `${Backofficebff}/v1/designcollective/getattachment`,
};
